// A group as Missions keeps it, and as @ofself/shell draws it.
//
// /api/groups passes Paradigm's /third-party/groups through, photo as
// `avatar_url`; the shell reads `avatarUrl`, so dropping it drew every group as
// letters while Nucleus showed its photo. The photo is a URL signed for an
// hour, so App.jsx re-reads the list on the avatar beat.

export const toShellGroup = (g) => ({
  id: g.id || g.group_id,
  name: g.name || g.title || 'Group',
  app_authorized: g.app_authorized,
  // Kept for the EP banner: only a group admin can authorize an app for a
  // group, so the banner offers the connect link only when it can work.
  role: g.role || null,
  avatarUrl: g.avatar_url || undefined,
});
